// extracted by mini-css-extract-plugin
export default {"root":"ItemStatus_root__lGGN4","todo":"ItemStatus_todo__p214n","done":"ItemStatus_done__tnVlI"};